import { motion } from "framer-motion";
import { MANIFESTO, STATS, IMAGES, BRAND } from "@/lib/data";

export const Manifesto = () => {
  return (
    <section
      id="about"
      className="py-24 lg:py-32 max-w-7xl mx-auto px-6"
      data-testid="about-section"
    >
      <div className="grid lg:grid-cols-12 gap-12">
        {/* Sticky label */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <p className="overline text-accent mb-6">01 / About Us</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-none tracking-tight text-foreground">
              A little store with a big heart, since {BRAND.established}.
            </h2>
            <div className="mt-10 overflow-hidden">
              <motion.img
                initial={{ scale: 1.2, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                src={IMAGES.storefront}
                alt="DV Mart Super Market storefront in Dabok, Udaipur"
                className="w-full aspect-[4/3] object-cover"
                data-testid="about-image"
              />
              <p className="mt-3 font-mono-label text-[0.65rem] uppercase tracking-widest text-muted-foreground">
                DV Mart · Dabok Chauraha, Udaipur
              </p>
            </div>
          </div>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-8 lg:pl-10">
          <div className="flex flex-col">
            {MANIFESTO.map((c, i) => (
              <motion.div
                key={c.no}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className={`py-12 ${i !== 0 ? "border-t border-border" : ""}`}
                data-testid={`manifesto-chapter-${c.no}`}
              >
                <div className="grid grid-cols-12 gap-6 items-start">
                  <span className="col-span-2 font-mono-label text-sm text-accent pt-2">
                    {c.no}
                  </span>
                  <div className="col-span-10">
                    <h3 className="font-display text-3xl sm:text-4xl leading-tight tracking-tight text-foreground">
                      {c.title}
                    </h3>
                    <p className="mt-5 text-muted-foreground text-base leading-relaxed max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Stats */}
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-border pt-12">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`stat-${i}`}
              >
                <div className="font-display text-4xl sm:text-5xl text-foreground tracking-tight">
                  {s.value}
                </div>
                <div className="mt-2 font-mono-label text-[0.65rem] uppercase tracking-widest text-muted-foreground">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
